import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
  Typography,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import React from "react";
import UploadPermits from "../../../../components/uploads/UploadPermits";
import Loader from "../../../../components/Loader";
import { useAttachedDocuments } from "./useAttachedDocuments";

function AttachedDocuments({ selectedPermit, isEditMode = false }) {
  const {
    data,
    isLoading,
    error,
    refetch,
    lookups,
    state,
    setter,
    handleUpdateState,
  } = useAttachedDocuments(selectedPermit);

  if (error) return "An error has occurred: " + error.message;
  return (
    <>
      {isLoading && (
        <Paper style={{ width: "100%", margin: "8px 0" }}>
          <Loader />
        </Paper>
      )}
      <Accordion
        defaultExpanded={isEditMode}
        disabled={!selectedPermit}
        style={{
          display: isLoading ? "none" : "block",
        }}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Box style={{ width: "100%" }}>
            <Typography variant="h3">Attached Documents</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <UploadPermits
            selectedNdx={selectedPermit}
            data={data}
            isLoading={isLoading}
            error={error}
            refetch={refetch}
            lookups={lookups}
            state={state}
            setter={setter}
            handleUpdateState={handleUpdateState}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default AttachedDocuments;
